import type { LpuBrandingBlockId } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_types'

/**
 * Пункт меню → ключ `block_order`.
 *
 * «Информация» совпадает с `gallery`: фотогалерея рендерится внутри этой секции.
 */
export const SECTION_MENU_BLOCK_ID: Record<string, LpuBrandingBlockId | undefined> = {
  doctors: 'doctors',
  schedule: 'work_schedule',
  rating: 'rating_and_rates',
  otzivi: 'rating_and_rates',
  prices: 'prices',
  akcii: 'promotions',
  documents: 'documents',
  'related-lpus': 'related_clinics',
  phonebook: 'phone_directory',
  interview: 'manager_interview',
  information: 'gallery',
}
